
import React from 'react';

const ChurchSteepleIntroduction = () => {
  return (
    <section id="introduction" className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold mb-10 text-center">North Carolina's Trusted Church Steeple Repair Specialists</h2>
        
        <div className="mb-10">
          <p className="mb-4 text-lg">Church steeples represent both architectural beauty and spiritual significance. At Carolina Trophy Roofs, we understand that repairing these distinctive structures requires specialized expertise beyond standard roofing practices.</p>
          
          <p className="mb-4">For over two decades, our master craftsmen have restored and repaired church steeples across Eastern North Carolina, combining traditional techniques with modern materials to ensure both aesthetic authenticity and lasting structural integrity.</p>
          
          <p>Our restoration methods follow guidelines established by the <a href="https://www.nps.gov/tps/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">National Park Service Technical Preservation Services</a> and <a href="https://www.presnc.org/" target="_blank" rel="noopener" className="text-brand-carolina-blue hover:underline">Preservation North Carolina</a>. Proper steeple maintenance extends structure lifespan by 35-50 years—yet 64% of historic church steeples in our state show signs of preventable damage according to preservation specialists.</p>
        </div>
      </div>
    </section>
  );
};

export default ChurchSteepleIntroduction;
